export default "__VITE_ASSET__DgXESS6L__"